import React, { useState } from 'react'
import { PhotoCamera } from '@material-ui/icons'
import SimpleActionPopup from '../../../components/SimpleActionPopup'
import FormInput from '../../../components/FormInput'

const CategoryPopup = ({ category, onClose, onSubmit, isLoading }) => {
  const [file, setFile] = useState(null)
  const [preview, setPreview] = useState(category ? category.url : null)
  const [data, setData] = useState({
    title_pt: category ? category.title_pt : '',
    group_type: category ? category.group : 'make_up',
    rank: category ? category.rank : 0
  })

  const groupOptions = [
    { value: 'make_up', label: 'Maquiagem' },
    { value: 'hair', label: 'Cabelo' },
    { value: 'look', label: 'Looks' },
    { value: 'accessory', label: 'Acessórios' }
  ]

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      setFile(selectedFile)
      setPreview(URL.createObjectURL(selectedFile))
    }
  }

  const handleCreate = () => {
    console.log({ ...data, file })
    onSubmit({ ...data, file })
  }

  const content = (
    /* Definimos uma largura mínima e usamos grid para colocar lado a lado */
    <div className='grid grid-cols-1 md:grid-cols-12 gap-8 p-4 min-w-[300px] md:min-w-[650px]'>
      
      {/* LADO ESQUERDO: Upload (Ocupa 5 colunas) */}
      <div className="md:col-span-5 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-all p-4 h-full min-h-[200px]">
        {preview ? (
          <div className="relative group">
            <img src={preview} className="w-32 h-32 object-cover rounded-xl shadow-lg border-2 border-white" alt="preview" />
            <div className="absolute inset-0 bg-black bg-opacity-40 rounded-xl opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity cursor-pointer">
              <PhotoCamera className="text-white" />
            </div>
          </div>
        ) : (
          <div className="text-center">
            <PhotoCamera className="text-gray-300" style={{ fontSize: 50 }} />
            <p className="text-gray-400 text-[10px] mt-2 font-bold uppercase tracking-wider">Ícone da Categoria</p>
          </div>
        )}
        
        <label className="mt-4 cursor-pointer bg-white border border-purple-200 px-4 py-2 rounded-xl text-[11px] font-black text-purple-600 shadow-sm hover:shadow-md transition-all active:scale-95">
          {preview ? 'ALTERAR IMAGEM' : 'SELECIONAR IMAGEM'}
          <input type="file" className="hidden" accept="image/*" onChange={handleImageChange} />
        </label>
      </div>

      {/* LADO DIREITO: Campos (Ocupa 7 colunas) */}
      <div className="md:col-span-7 flex flex-col justify-center space-y-4">
        <FormInput 
          label="Nome da Categoria (PT)*" 
          placeholder="Ex: Batom Matte"
          value={data.title_pt} 
          onChange={e => setData({...data, title_pt: e.target.value})} 
        />
        
        <div className="grid grid-cols-2 gap-4">
          {/* Agora o Dropdown segue exatamente o padrão do FormInput */}
          <FormInput
            label="Grupo Pai"
            selectOptions={groupOptions}
            defaultValueOption={groupOptions.find(opt => opt.value === data.group_type)}
            onChange={(opt) => setData({...data, group_type: opt.value})}
            placeholder="Selecione..."
          />

          <FormInput 
            label="Ordem (Rank)" 
            type="number"
            value={data.rank} 
            onChange={e => setData({...data, rank: e.target.value})} 
          />
        </div>
        
        <p className="text-[10px] text-gray-400 italic">
          * Campos obrigatórios. A categoria será criada como "Publicada" por padrão.
        </p>
      </div>
    </div>
  )

  return (
    <SimpleActionPopup
      title={category ? "Editar Categoria" : "Nova Categoria de Coloração"}
      secondActionButtonText={category ? "SALVAR ALTERAÇÕES" : "CRIAR CATEGORIA"}
      content={content}
      onClosePopup={onClose}
      onPressSecondActionButton={handleCreate}
      popupLoading={isLoading}
    />
  )
}

export default CategoryPopup